import { Button } from "@/components/ui/button";
import { InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { InputOTP } from "@/components/ui/input-otp";
import { Label } from "@/components/ui/label";
// @ts-expect-error -- untyped module
import mfaSendOtp from "@/assets/mfa-send-otp.svg";
import { useMMfaLoginOtp, useMMfaLoginResendOtp } from "@/hooks/use-mfa-login";
import { useForm } from "@tanstack/react-form";
import useAuth from "@/context/auth-provider";
import { useLocation, useNavigate } from "react-router-dom";
import { resetPasswordSchema } from "@/lib/form-schema";
import useUserInfo from "@/hooks/use-user-info";
import ScreenRouteNames from "@/constants/screen-route-names";

const MfaLogin = () => {
  const navigate = useNavigate();
  const userInfo = useUserInfo();
  const { updateAuthData } = useAuth();
  const { username, signature } = useLocation().state as {
    username: string;
    signature: string;
  };
  const mfaLoginQuery = useMMfaLoginOtp();
  const mfaLoginOtpResendQuery = useMMfaLoginResendOtp();

  const handleResendOtp = () => {
    mfaLoginOtpResendQuery.mutate({
      divisionId: userInfo?.divisionId,
      groupId: userInfo?.groupId,
      loginGroupId: userInfo?.loginGroupId,
      username,
      signature,
    });
  };

  const form = useForm({
    defaultValues: {
      enteredOTP: "",
    },

    onSubmit: ({ value }) =>
      mfaLoginQuery.mutate(
        {
          divisionId: userInfo?.divisionId,
          groupId: userInfo?.groupId,
          loginGroupId: userInfo?.loginGroupId,
          enteredOTP: value.enteredOTP,
          username,
          signature,
        },
        {
          // onSuccess: () => {
          //   navigate(`/${ScreeRouteNames.HOME}`);
          // },
          onSuccess: async (response) => {
            if (response.success) {
              await updateAuthData({
                user: response,
                mode: "member",
              });

              navigate(`/${ScreenRouteNames.HOME.path}`);
            } else {
              navigate(`/${ScreenRouteNames.LOGIN.path}`);
            }
          },
        },
      ),
  });
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="rounded-lg px-16 py-10 sm:border sm:shadow-lg">
        <form
          className="flex flex-col justify-between gap-8 text-center sm:w-auto lg:w-[260px]"
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            form.handleSubmit();
          }}
        >
          <h4>Multi Factor Authentication</h4>
          <div className="grid grid-cols-1 place-items-center gap-6">
            <img src={mfaSendOtp} className="size-20" alt="" />
            <Label className="text-lg font-bold">Verify OTP</Label>
            <div className="flex flex-col gap-1 text-center">
              <Label className="text-sm/6">
                Please enter the OTP sent to your email
              </Label>
            </div>
            <div className="flex gap-2">
              <form.Field
                name="enteredOTP"
                validators={{
                  onChange: ({ value }) => {
                    const result =
                      resetPasswordSchema.shape.otp.safeParse(value);
                    return result.success
                      ? undefined
                      : result.error.errors[0].message;
                  },
                }}
              >
                {(field) => (
                  <InputOTP
                    maxLength={6}
                    value={field.state.value}
                    onChange={(val) => field.handleChange(val)}
                    onBlur={() => field.handleBlur()}
                  >
                    <InputOTPGroup>
                      <InputOTPSlot index={0} />
                      <InputOTPSlot index={1} />
                      <InputOTPSlot index={2} />
                      <InputOTPSlot index={3} />
                      <InputOTPSlot index={4} />
                      <InputOTPSlot index={5} />
                    </InputOTPGroup>
                  </InputOTP>
                )}
              </form.Field>
            </div>
            <div className="flex items-center text-center">
              <Label>Don&apos;t Receive OTP?</Label>
              <Button
                variant="link"
                type="button"
                className="h-6 hover:underline"
                onClick={handleResendOtp}
              >
                Resend OTP
              </Button>
            </div>
          </div>
          <div className="flex justify-center gap-4">
            <Button type="submit" className="w-32 rounded-sm">
              Verify OTP
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MfaLogin;
